module.exports = __webpack_public_path__ + "static/img/rank_2.8b4749d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_2.png
// module id = rQzs
// module chunks = 0